module.exports = __webpack_public_path__ + "media/img/pages/profile/axpo ger 1-783959af0b6e2620a5fd208f38379b27.jpg";